
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gC9ew", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("aT8t4")).default; });

var $aT8t4 = parcelRequire("aT8t4");

});
parcelRegister("aT8t4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $779847b443bf05b9$export$2e2bcd8739ae039; });
/* price-calculator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $4G0xh = parcelRequire("4G0xh");

var $kbpa7 = parcelRequire("kbpa7");

var $8bW04 = parcelRequire("8bW04");

var $gJe05 = parcelRequire("gJe05");
parcelRequire("hEIeM");
var $44bDI = parcelRequire("44bDI");
var $5TIjy = parcelRequire("5TIjy");
parcelRequire("hEIeM");
var $MgH7i = parcelRequire("MgH7i");
parcelRequire("b9I0b");
var $fEBe5 = parcelRequire("fEBe5");

var $aLva8 = parcelRequire("aLva8");

var $fhn1A = parcelRequire("fhn1A");

var $9evy5 = parcelRequire("9evy5");

var $juRep = parcelRequire("juRep");
const $779847b443bf05b9$var$RecommendationTracker = ({ plan: plan, index: index, onRecommendedChange: onRecommendedChange })=>{
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: plan.fields.sku
    });
    (0, $1oC0p.useEffect)(()=>{
        onRecommendedChange(index, state.recommended);
    }, [
        index,
        state.recommended,
        onRecommendedChange
    ]);
    return null;
};
const $779847b443bf05b9$var$PricingCalculatorContent = ({ comparePlansData: comparePlansData, urlSlug: urlSlug, selectedCardIndex: selectedCardIndex, setSelectedCardIndex: setSelectedCardIndex, disclaimer: disclaimer, omitInputs: omitInputs, numSections: numSections })=>{
    const intl = (0, $8e22h.default)();
    const handleRecommendedChange = (0, $1oC0p.useCallback)((index, isRecommended)=>{
        if (isRecommended) setSelectedCardIndex(index);
    }, [
        setSelectedCardIndex
    ]);
    const unitsLabel = $779847b443bf05b9$var$useUnitsLabel(comparePlansData);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            comparePlansData.length > 1 && comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($779847b443bf05b9$var$RecommendationTracker, {
                    plan: planData,
                    index: index,
                    onRecommendedChange: handleRecommendedChange
                }, `tracker-${planData.fields.sku}`)),
            !omitInputs && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MgH7i.PricingCalculatorInputs), {
                unitCountLabel: intl.formatMessage($9evy5.units.teamSizePrompt),
                unitsLabel: unitsLabel,
                dataProductKey: (0, $4G0xh.urlSlugToDataProductKey)[urlSlug]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8bW04.PricingCards), {
                // must set the number of sections here if removing the bottom section
                // could also infer this from planData's getFeaturesList(fields.highlightedFeaturesContainer)
                numSections: numSections,
                selectedCardIndex: selectedCardIndex ? selectedCardIndex + 1 : 1,
                children: comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $juRep.PricingCalculatorCard), {
                        showBannerText: comparePlansData.length > 1,
                        planData: planData,
                        urlSlug: urlSlug,
                        index: index,
                        isSingleCard: comparePlansData.length === 1
                    }, planData.fields.sku))
            }),
            disclaimer && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_p12frdnh _k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1hlo _1yt4utpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: disclaimer
                })
            })
        ]
    });
};
const $779847b443bf05b9$var$disclaimerContainerCss = null;
const $779847b443bf05b9$var$disclaimerCss = null;
const $779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX = 2;
const $779847b443bf05b9$var$UniformPricingCalculator = (props)=>{
    var _comparePlansData__fields, _comparePlansData_;
    const { comparePlansData: comparePlansData, urlSlug: urlSlug, disclaimer: disclaimer, inputs: inputs, onChangeInputs: onChangeInputs, getDiscountedPrice: getDiscountedPrice } = props;
    const [selectedCardIndex, setSelectedCardIndex] = (0, $1oC0p.useState)($779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX);
    const providerResult = (0, $fhn1A.useProviderProps)({
        plans: comparePlansData,
        product: urlSlug,
        inputValues: inputs
    });
    if (providerResult.status === "pending") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5TIjy.LoadingSpinner), {});
    if (providerResult.status === "error") return null; // todo: fire an event @bsparks GWP-6943
    if (providerResult.status !== "ready") return null; // this should never happen due to checks above, but fixes type error
    const { config: config, inputValues: inputValues } = providerResult.props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aLva8.PricingCalculatorContextProvider), {
        config: config,
        inputValues: inputValues,
        onChangeInputs: onChangeInputs,
        getDiscountedPrice: getDiscountedPrice,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($779847b443bf05b9$var$PricingCalculatorContent, {
            comparePlansData: comparePlansData,
            urlSlug: urlSlug,
            selectedCardIndex: selectedCardIndex,
            setSelectedCardIndex: setSelectedCardIndex,
            disclaimer: disclaimer,
            numSections: (0, $44bDI.getFeaturesList)(comparePlansData === null || comparePlansData === void 0 ? void 0 : (_comparePlansData_ = comparePlansData[0]) === null || _comparePlansData_ === void 0 ? void 0 : (_comparePlansData__fields = _comparePlansData_.fields) === null || _comparePlansData__fields === void 0 ? void 0 : _comparePlansData__fields.highlightedFeaturesContainer) === undefined ? 1 : 2,
            omitInputs: !config.billingCycleConfig.monthly && !config.billingCycleConfig.annual
        })
    });
};
var $779847b443bf05b9$export$2e2bcd8739ae039 = $779847b443bf05b9$var$UniformPricingCalculator;
function $779847b443bf05b9$var$useUnitsLabel(comparePlansData) {
    const intl = (0, $8e22h.default)();
    const hasAgents = comparePlansData.some((plan)=>{
        return [
            (0, $fEBe5.serviceCollectionOfferingSkus).free,
            (0, $fEBe5.serviceCollectionOfferingSkus).standard,
            (0, $fEBe5.serviceCollectionOfferingSkus).premium,
            (0, $fEBe5.serviceCollectionOfferingSkus).enterprise
        ].includes(plan.fields.sku);
    });
    if (hasAgents) return intl.formatMessage($9evy5.units.agentsUnitsLabel);
    return intl.formatMessage($9evy5.units.usersUnitsLabel);
}

});
parcelRegister("4G0xh", function(module, exports) {
$parcel$export(module.exports, "urlSlugToDataProductKey", function () { return $ceccdba2041bfa64$export$9c59efe722f16a54; });
const $ceccdba2041bfa64$export$e36fc9e5c75fc113 = "jiraSoftware";
const $ceccdba2041bfa64$export$b65b36d21c9a62a9 = "confluence";
const $ceccdba2041bfa64$export$b24966420407028a = "strategyCollection";
const $ceccdba2041bfa64$export$46061d552ba374f4 = "teamworkCollection";
const $ceccdba2041bfa64$export$e7e2043098922532 = "compass";
const $ceccdba2041bfa64$export$6648fdba742bde2c = "serviceCollection";
const $ceccdba2041bfa64$export$b3fce742f95b2633 = "atlassianGuard";
const $ceccdba2041bfa64$export$9c59efe722f16a54 = {
    jira: $ceccdba2041bfa64$export$e36fc9e5c75fc113,
    confluence: $ceccdba2041bfa64$export$b65b36d21c9a62a9,
    strategy: $ceccdba2041bfa64$export$b24966420407028a,
    teamwork: $ceccdba2041bfa64$export$46061d552ba374f4,
    compass: $ceccdba2041bfa64$export$e7e2043098922532,
    service: $ceccdba2041bfa64$export$6648fdba742bde2c,
    guard: $ceccdba2041bfa64$export$b3fce742f95b2633
};

});

parcelRegister("8bW04", function(module, exports) {
$parcel$export(module.exports, "PricingCards", function () { return $6b8bae1d092d0de9$export$eb5ade451900e238; });
/* pricing-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $6b8bae1d092d0de9$export$eb5ade451900e238 = (props)=>{
    const { selectedCardIndex: selectedCardIndex, children: children, numSections: numSections = 2, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasLinkSlot: hasLinkSlot, hasBannerSlot: hasBannerSlot } = props;
    const numberOfChildren = (0, $1oC0p.Children).count(children);
    const getBorderProps = (childIndex, numSections)=>{
        if (numSections !== 1) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        return {
            topSectionStyle: {
                borderStartEndRadius: isFirstChild ? "0" : undefined,
                borderEndEndRadius: isFirstChild ? "0px" : undefined,
                borderStartStartRadius: isLastChild ? "0" : undefined,
                borderEndStartRadius: isLastChild ? "0px" : undefined
            }
        };
    };
    const getSelectedBorderProps = (childIndex)=>{
        if (selectedCardIndex === undefined || selectedCardIndex !== childIndex) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        const blackBorder = `1px solid ${(0, $kbpa7.wacToken)("color.primary.black")}`;
        return {
            topSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockStart: blackBorder,
                borderLeftRadius: "10px",
                borderTopRightRadius: numSections === 1 && isLastChild ? "20px" : undefined,
                borderBottomLeftRadius: numSections === 1 && isLastChild ? "0px" : undefined,
                borderBottomRightRadius: numSections === 1 && isFirstChild ? "0px" : undefined,
                borderRadius: numSections === 1 && !isFirstChild && !isLastChild ? `0px` : undefined,
                borderBottom: numSections === 1 ? blackBorder : undefined
            },
            bottomSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockEnd: blackBorder
            }
        };
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_2z054em0 _yv0e1579 _1e0c11p5 _wij21bp4 _1bsb1ns9 _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _glte1ns9 _1ao8yzqy _37tx5os2 _11nh5os2 _157nyzqy _1r9zyzqy _qrtggktf _bzkjkpzv _bi30wrl1 _x330kpzv _1q1tyzqy _14bpgktf _uedh18ji _sqhgyzqy _1bs9gktf _1o36gktf _r0rayzqy _23ugyzqy _4ezvyzqy",
            numSections !== 1 && "_1aqcftgi",
            "_1mjb1txw _na0i1bp4 _1s4p1osq _1a7ngktf _1xwygktf _9h3lyzqy _9rrkyzqy _18xwyzqy",
            numSections === 1 && "_pmhu1txs _ukazftgi _i370yzqy _1635yzqy"
        ]),
        style: {
            "--_wcq253": (0, $6ZVlx.default)(numSections),
            "--_1j6te2o": (0, $6ZVlx.default)(numberOfChildren),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_vgqxqn": (0, $6ZVlx.default)(numSections === 1 ? `1px solid ${(0, $kbpa7.wacToken)("color.neutral.light400")}` : undefined),
            "--_3ro2cj": (0, $6ZVlx.default)(numSections === 1 ? "0px" : "20px"),
            "--_14z1886": (0, $6ZVlx.default)(numSections === 1 ? "0px" : undefined),
            "--_1ecp6y0": (0, $6ZVlx.default)(numSections === 1 ? "20px" : undefined)
        },
        children: (0, $1oC0p.Children).map(children, (child, index)=>{
            if (!child) return null;
            return /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, (0, $6ogO3._)({
                key: index,
                hasCalloutSlot: hasCalloutSlot,
                hasRangeSlot: hasRangeSlot,
                hasLinkSlot: hasLinkSlot,
                hasBannerSlot: hasBannerSlot
            }, index + 1 === selectedCardIndex ? getSelectedBorderProps(index + 1) : getBorderProps(index + 1, numSections)));
        })
    });
};

});

parcelRegister("gJe05", function(module, exports) {
$parcel$export(module.exports, "useCalculationState", function () { return $ffe53822942d34d9$export$5ac48a71a65a15bc; });

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
function $ffe53822942d34d9$export$5ac48a71a65a15bc(props) {
    const { offeringSku: offeringSku } = props;
    return {
        billingCycle: (0, $1CtPM.useSelector)($3V3tC.getBillingCycle),
        isUnitCountAboveMaxThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountAboveMaxThreshold(ctx, offeringSku)),
        unitCountMin: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCountMinThreshold(ctx, offeringSku)),
        isUnitCountBelowMinThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountBelowMinThreshold(ctx, offeringSku)),
        price: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getFormattedPlanPrice(ctx, offeringSku)),
        recommended: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isOfferingRecommended(ctx, offeringSku)),
        unitCount: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCount(ctx)),
        unitTierLowerBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierLowerBound(ctx, offeringSku)),
        unitTierUpperBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierUpperBound(ctx, offeringSku)),
        unitsAvailableInTier: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitsAvailableInTier(ctx, offeringSku)),
        numberFormatLocale: (0, $1CtPM.useSelector)($3V3tC.getNumberFormatLocale)
    };
}

});
parcelRegister("1CtPM", function(module, exports) {
$parcel$export(module.exports, "useUnitCount", function () { return $f242ee1b597a5061$export$856785685ba8098f; });
$parcel$export(module.exports, "useBillingCycle", function () { return $f242ee1b597a5061$export$ada282ac321ec3b9; });
$parcel$export(module.exports, "useSelector", function () { return $f242ee1b597a5061$export$2105062e25df4afe; });
$parcel$export(module.exports, "useCcpPricingData", function () { return $f242ee1b597a5061$export$97374d6e908d2c; });

var $1oC0p = parcelRequire("1oC0p");

var $dkcYJ = parcelRequire("dkcYJ");

var $aLva8 = parcelRequire("aLva8");
function $f242ee1b597a5061$export$856785685ba8098f() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { unitCount: unitCount } = inputValues;
    const changeUnitCount = (value)=>{
        return changeInputValues({
            unitCount: value
        });
    };
    return [
        unitCount,
        changeUnitCount
    ];
}
function $f242ee1b597a5061$export$ada282ac321ec3b9() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { billingCycle: billingCycle } = inputValues;
    const changeBillingCycle = (value)=>{
        return changeInputValues({
            billingCycle: value
        });
    };
    return [
        billingCycle,
        changeBillingCycle
    ];
}
function $f242ee1b597a5061$export$f3fe2cc7a9497569() {
    return (0, $aLva8.usePricingCalculatorContext)().calculationResult;
}
const $f242ee1b597a5061$export$2105062e25df4afe = (selector)=>{
    const context = (0, $aLva8.usePricingCalculatorContext)();
    return selector(context);
};
const $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $f242ee1b597a5061$export$97374d6e908d2c = (props)=>{
    const { offeringSkus: offeringSkus, ssrData: ssrData } = props;
    const { fetchData: fetchData, status: fetchStatus, prices: clientSideData } = (0, $dkcYJ.useCCPPriceFinderData)(offeringSkus, $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY, $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE);
    const execFetch = (0, $1oC0p.useCallback)(async ()=>{
        await fetchData();
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!ssrData) execFetch();
    }, []);
    const status = $f242ee1b597a5061$var$getCcpPricingDataStatus({
        hasSsrData: !!ssrData,
        fetchStatus: fetchStatus
    });
    return {
        data: ssrData !== null && ssrData !== void 0 ? ssrData : clientSideData,
        status: status
    };
};
function $f242ee1b597a5061$var$getCcpPricingDataStatus(args) {
    const { fetchStatus: fetchStatus, hasSsrData: hasSsrData } = args;
    if (hasSsrData || fetchStatus === "complete") return "ready";
    if (fetchStatus === "idle" || fetchStatus === "fetching") return "pending";
    return "error";
}

});
parcelRegister("aLva8", function(module, exports) {
$parcel$export(module.exports, "usePricingCalculatorContext", function () { return $368a3b873d7337e6$export$cf6d27bb6377cd5b; });
$parcel$export(module.exports, "PricingCalculatorContextProvider", function () { return $368a3b873d7337e6$export$5a79cf764fd87278; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("7HfJk");
var $5CQu1 = parcelRequire("5CQu1");
var $8cfMz = parcelRequire("8cfMz");
const $368a3b873d7337e6$var$PricingCalculatorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $368a3b873d7337e6$export$cf6d27bb6377cd5b = ()=>{
    const pricingCalculatorContext = (0, $1oC0p.useContext)($368a3b873d7337e6$var$PricingCalculatorContext);
    if (!pricingCalculatorContext) throw new Error("usePricingCalculatorContext must be used within a PricingCalculatorProvider");
    return pricingCalculatorContext;
};
const $368a3b873d7337e6$export$5a79cf764fd87278 = (props)=>{
    const [inputValues, setInputValues] = (0, $1oC0p.useState)(props.inputValues);
    const calculate = (0, $1oC0p.useCallback)((v)=>{
        const { config: config } = props;
        const productCalculationInputs = (0, $8cfMz.getProductCalculationInputs)(config.planLimitConfigs, config.unitMinEnterprise, v.unitCount, v.billingCycle);
        return (0, $5CQu1.calculateProductPricing)(config.ccpPricingData, productCalculationInputs, config.currencyISOCode, config.localeISOCode);
    }, [
        props
    ]);
    const [calculationResult, setCalculationResult] = (0, $1oC0p.useState)(()=>calculate(inputValues));
    // Recalculate when config (including currency) changes
    (0, $1oC0p.useEffect)(()=>{
        const result = calculate(inputValues);
        setCalculationResult(result);
    }, [
        props.config,
        inputValues,
        calculate
    ]);
    const changeInputValues = (changes)=>{
        var _props_onChangeInputs;
        const nextValues = (0, $6ogO3._)({}, inputValues, changes);
        setInputValues(nextValues);
        (_props_onChangeInputs = props.onChangeInputs) === null || _props_onChangeInputs === void 0 ? void 0 : _props_onChangeInputs.call(props, nextValues);
        const result = calculate(nextValues);
        setCalculationResult(result);
        return result;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($368a3b873d7337e6$var$PricingCalculatorContext.Provider, {
        value: {
            inputValues: inputValues,
            changeInputValues: changeInputValues,
            calculationResult: calculationResult,
            config: props.config,
            getDiscountedPrice: props.getDiscountedPrice
        },
        children: props.children
    });
};

});
parcelRegister("7HfJk", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return (parcelRequire("5CQu1")).calculateProductPricing; });
$parcel$export(module.exports, "getProductCalculationInputs", function () { return (parcelRequire("8cfMz")).getProductCalculationInputs; });
parcelRequire("5CQu1");
parcelRequire("8cfMz");

});
parcelRegister("5CQu1", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return $a686a54aa7deba91$export$6c0aa9d51dade71d; });

var $6ogO3 = parcelRequire("6ogO3");

var $1mbEv = parcelRequire("1mbEv");
const $a686a54aa7deba91$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $1mbEv.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push((0, $6ogO3._)({
            // @ts-ignore
            offeringSku: ccpOfferingSKU
        }, planPricing));
    }
    return productPricing;
};

});
parcelRegister("1mbEv", function(module, exports) {
$parcel$export(module.exports, "calculatePlanPricing", function () { return $0f584d23bad95648$export$f9574505c9651410; });

var $6ogO3 = parcelRequire("6ogO3");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");

var $1RK9J = parcelRequire("1RK9J");

var $aTHox = parcelRequire("aTHox");
parcelRequire("b9I0b");
var $9Nmuw = parcelRequire("9Nmuw");
const $0f584d23bad95648$var$hamsPricingDataStub = {};
const $0f584d23bad95648$var$hamsProductKeyStub = "";
function $0f584d23bad95648$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return (0, $6ogO3._)({
        offeringSku: ccpOfferingSKU
    }, (0, $1RK9J.getFreePriceCalc)(currencyISOCode));
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $9Nmuw.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === "user");
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, $0f584d23bad95648$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $0f584d23bad95648$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return (0, $6ogO3._)({
                offeringSku: ccpOfferingSKU
            }, (0, $1RK9J.getFreePriceCalc)(currencyISOCode));
        } else return (0, $6ogO3._)({
            offeringSku: ccpOfferingSKU
        }, (0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
}

});
parcelRegister("aTHox", function(module, exports) {
$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $4c3894076c255a40$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $4c3894076c255a40$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $4c3894076c255a40$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $4c3894076c255a40$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $4c3894076c255a40$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $4c3894076c255a40$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $4c3894076c255a40$export$f9cab01559b23739; });
const $4c3894076c255a40$export$6e78cb64dcbedbb9 = "MONTHLY";
const $4c3894076c255a40$export$36a5806a0e4fc360 = 5;
const $4c3894076c255a40$export$2b15976b7672c2da = 201;
const $4c3894076c255a40$export$eeb88db779daf862 = {
    free: "bitbucket-test-free",
    standard: "bitbucket-std",
    premium: "bitbucket-premium"
};
const $4c3894076c255a40$export$4d264dc26702f23b = 35000;
const $4c3894076c255a40$export$9a2735659d85fd7c = Object.values($4c3894076c255a40$export$eeb88db779daf862);
const $4c3894076c255a40$export$66d05a9262b43b7f = [
    {
        planName: "Free",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: "Standard",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: "Premium",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    }
];
const $4c3894076c255a40$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("b9I0b", function(module, exports) {
$parcel$export(module.exports, "jiraOfferingSkus", function () { return (parcelRequire("j1ORI")).jiraOfferingSkus; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return (parcelRequire("29JVp")).confluenceOfferingSkus; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return (parcelRequire("hGYMM")).strategyCollectionOfferingSkus; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return (parcelRequire("YmHME")).teamworkCollectionOfferingSkus; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return (parcelRequire("4utnL")).loomOfferingSkus; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return (parcelRequire("lc7EO")).jpdOfferingSkus; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return (parcelRequire("7dhmX")).compassOfferingSkus; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return (parcelRequire("44C4o")).guardOfferingSkus; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return (parcelRequire("fEBe5")).serviceCollectionOfferingSkus; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return (parcelRequire("9Nmuw")).rovoDevOfferingSkus; });
parcelRequire("j1ORI");
parcelRequire("29JVp");
parcelRequire("hGYMM");
parcelRequire("YmHME");
parcelRequire("4utnL");
parcelRequire("gcAZd");
parcelRequire("lc7EO");
parcelRequire("7dhmX");
parcelRequire("44C4o");
parcelRequire("fEBe5");
parcelRequire("9Nmuw");

});
parcelRegister("j1ORI", function(module, exports) {
$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $2a2b2c5bc611aa86$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $2a2b2c5bc611aa86$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $2a2b2c5bc611aa86$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $2a2b2c5bc611aa86$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $2a2b2c5bc611aa86$export$3070b86c7bc28aea; });
const $2a2b2c5bc611aa86$export$c34e5566df36b6ba = "MONTHLY";
const $2a2b2c5bc611aa86$export$6521a918e64524fb = 300;
const $2a2b2c5bc611aa86$export$9aef50cd5f48bb38 = 801;
const $2a2b2c5bc611aa86$export$7529f2cfeec98447 = {
    free: "jira-software-free",
    standard: "jira-software-standard",
    premium: "jira-software-premium",
    enterprise: "jira-software-enterprise-sku"
};
const $2a2b2c5bc611aa86$export$b2b09200ca76754f = Object.values($2a2b2c5bc611aa86$export$7529f2cfeec98447);
const $2a2b2c5bc611aa86$export$3070b86c7bc28aea = [
    {
        planName: "Free",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Standard",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $2a2b2c5bc611aa86$export$9aef50cd5f48bb38
    }
];
const $2a2b2c5bc611aa86$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("29JVp", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $1e226e69d394223a$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $1e226e69d394223a$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $1e226e69d394223a$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $1e226e69d394223a$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $1e226e69d394223a$export$53fbba6eb29a73ad; });
const $1e226e69d394223a$export$d60dc2d142b5e9dd = "MONTHLY";
const $1e226e69d394223a$export$ab3750ec8101ffcc = 300;
const $1e226e69d394223a$export$f76a76b996ace375 = 801;
const $1e226e69d394223a$export$ffe6d3f38b5f7c3a = {
    free: "confluence-free",
    standard: "confluence-standard",
    premium: "confluence-premium",
    enterprise: "confluence-enterprise-sku"
};
const $1e226e69d394223a$export$39e8fbae2abd0443 = Object.values($1e226e69d394223a$export$ffe6d3f38b5f7c3a);
const $1e226e69d394223a$export$53fbba6eb29a73ad = [
    {
        planName: "Free",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 150000
    },
    {
        planName: "Standard",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 150000
    },
    {
        planName: "Premium",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 150000
    },
    {
        planName: "Enterprise",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 150000,
        minUnitCount: $1e226e69d394223a$export$f76a76b996ace375
    }
];
const $1e226e69d394223a$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("hGYMM", function(module, exports) {
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $45ceb3dd2bb22ad6$export$c00ddd271304729a; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $45ceb3dd2bb22ad6$export$27579c7f06007c25; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return $45ceb3dd2bb22ad6$export$8427e2db10f569be; });
$parcel$export(module.exports, "strategyCollectionPlanLimitConfigs", function () { return $45ceb3dd2bb22ad6$export$bc4927fbd68771ac; });
$parcel$export(module.exports, "strategyCollectionBillingCycleConfig", function () { return $45ceb3dd2bb22ad6$export$2225b2a65811f064; });
const $45ceb3dd2bb22ad6$export$c00ddd271304729a = "ANNUAL";
const $45ceb3dd2bb22ad6$export$27579c7f06007c25 = 50;
const $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a = 50;
const $45ceb3dd2bb22ad6$export$8427e2db10f569be = {
    enterprise: "strategy-collection-enterprise-sku"
};
const $45ceb3dd2bb22ad6$export$3b4c7d53b38ef615 = Object.values($45ceb3dd2bb22ad6$export$8427e2db10f569be);
const $45ceb3dd2bb22ad6$export$bc4927fbd68771ac = [
    {
        planName: "Enterprise",
        offeringSku: $45ceb3dd2bb22ad6$export$8427e2db10f569be.enterprise,
        recommendationLimit: 2000,
        signupLimit: 2000,
        minUnitCount: $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a
    }
];
const $45ceb3dd2bb22ad6$export$2225b2a65811f064 = {
    monthly: false,
    annual: true
};

});

parcelRegister("YmHME", function(module, exports) {
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $bf49a3d87bcf04a1$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $bf49a3d87bcf04a1$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $bf49a3d87bcf04a1$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $bf49a3d87bcf04a1$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $bf49a3d87bcf04a1$export$5861c5ce06e1556; });
const $bf49a3d87bcf04a1$export$5784a04bb778d3c1 = "MONTHLY";
const $bf49a3d87bcf04a1$export$482604a575f7b4a5 = 300;
const $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2 = 801;
const $bf49a3d87bcf04a1$export$2e2107bfa20be1d8 = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
};
const $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4 = Object.values($bf49a3d87bcf04a1$export$2e2107bfa20be1d8);
const $bf49a3d87bcf04a1$export$88bcddbae46dd5f1 = [
    {
        planName: "Free",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: "Standard",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2
    }
];
const $bf49a3d87bcf04a1$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});

parcelRegister("4utnL", function(module, exports) {
$parcel$export(module.exports, "LOOM_DEFAULT_BILLING_CYCLE", function () { return $567bad4c99b6ec03$export$501dc9dfd5b2bde4; });
$parcel$export(module.exports, "LOOM_DEFAULT_UNIT_COUNT", function () { return $567bad4c99b6ec03$export$2aa1a93e0ac00fc; });
$parcel$export(module.exports, "LOOM_MIN_ENTERPRISE_USER_COUNT", function () { return $567bad4c99b6ec03$export$2a2f7d7a7ae18850; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return $567bad4c99b6ec03$export$a64578a63428ae96; });
$parcel$export(module.exports, "loomPlanLimitConfigs", function () { return $567bad4c99b6ec03$export$ed1379ed8713d252; });
$parcel$export(module.exports, "loomBillingCycleConfig", function () { return $567bad4c99b6ec03$export$d2bfeac6f7899675; });
const $567bad4c99b6ec03$export$501dc9dfd5b2bde4 = "MONTHLY";
const $567bad4c99b6ec03$export$2aa1a93e0ac00fc = 100;
const $567bad4c99b6ec03$export$2a2f7d7a7ae18850 = Infinity;
const $567bad4c99b6ec03$export$a64578a63428ae96 = {
    free: "loom-free-sku",
    business: "loom-business-sku",
    businessPlusAi: "loom-business-ai-sku",
    enterprise: "loom-enterprise-sku"
};
const $567bad4c99b6ec03$export$9f95f1c871571078 = Object.values($567bad4c99b6ec03$export$a64578a63428ae96);
const $567bad4c99b6ec03$export$ed1379ed8713d252 = [
    {
        planName: "Free",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business + AI",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Enterprise",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $567bad4c99b6ec03$export$d2bfeac6f7899675 = {
    monthly: true,
    annual: true
};

});

parcelRegister("gcAZd", function(module, exports) {
const $ff47f9ee8d194adc$export$be354061b07829a8 = "MONTHLY";
const $ff47f9ee8d194adc$export$2295858875312a6f = 75;
const $ff47f9ee8d194adc$export$66d53803b4a2565a = 201;
const $ff47f9ee8d194adc$export$38631f866342776a = {
    free: "jira-servicedesk-free",
    standard: "jira-servicedesk-standard",
    premium: "jira-servicedesk-premium",
    enterprise: "jira-servicedesk-enterprise-sku"
};
const $ff47f9ee8d194adc$export$efd16829e921ffb8 = Object.values($ff47f9ee8d194adc$export$38631f866342776a);
const $ff47f9ee8d194adc$export$9e62e4d7dc794618 = [
    {
        planName: "Free",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $ff47f9ee8d194adc$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("lc7EO", function(module, exports) {
$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $a2567840a72a8d9f$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $a2567840a72a8d9f$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $a2567840a72a8d9f$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $a2567840a72a8d9f$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $a2567840a72a8d9f$export$370b1f24abd91670; });
const $a2567840a72a8d9f$export$513f99bdcd3bd2 = "MONTHLY";
const $a2567840a72a8d9f$export$503245d941330408 = 10;
const $a2567840a72a8d9f$export$4ebabaf17c585254 = 201;
const $a2567840a72a8d9f$export$400db592c8d58797 = {
    free: "jira-servicedesk-free",
    // jpd-free shares the same sku as jsm-free
    standard: "jira-product-discovery-standard",
    premium: "jira-product-discovery-premium-sku"
};
const $a2567840a72a8d9f$export$cf1798af40f51188 = Object.values($a2567840a72a8d9f$export$400db592c8d58797);
const $a2567840a72a8d9f$export$886e6b42d7675517 = [
    {
        planName: "Free",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    }
];
const $a2567840a72a8d9f$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};

});

parcelRegister("7dhmX", function(module, exports) {
$parcel$export(module.exports, "COMPASS_DEFAULT_BILLING_CYCLE", function () { return $50757f59ceb0cbe4$export$2c789441f8bab310; });
$parcel$export(module.exports, "COMPASS_DEFAULT_UNIT_COUNT", function () { return $50757f59ceb0cbe4$export$887bc0e84eafd3c; });
$parcel$export(module.exports, "COMPASS_MIN_ENTERPRISE_USER_COUNT", function () { return $50757f59ceb0cbe4$export$862352663e0ac9d7; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return $50757f59ceb0cbe4$export$f93fb5caff8c778a; });
$parcel$export(module.exports, "compassPlanLimitConfigs", function () { return $50757f59ceb0cbe4$export$4df3b64d28e0d138; });
$parcel$export(module.exports, "compassBillingCycleConfig", function () { return $50757f59ceb0cbe4$export$e0b3f0eba764d747; });
const $50757f59ceb0cbe4$export$2c789441f8bab310 = "MONTHLY";
const $50757f59ceb0cbe4$export$887bc0e84eafd3c = 300;
const $50757f59ceb0cbe4$export$862352663e0ac9d7 = Infinity;
const $50757f59ceb0cbe4$export$f93fb5caff8c778a = {
    free: "compass-free",
    standard: "compass-standard",
    premium: "compass-premium-sku"
};
const $50757f59ceb0cbe4$export$74a0fd94f40ef5c5 = Object.values($50757f59ceb0cbe4$export$f93fb5caff8c778a);
const $50757f59ceb0cbe4$export$4df3b64d28e0d138 = [
    {
        planName: "Free",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: "Standard",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.standard,
        recommendationLimit: 3,
        signupLimit: 35000
    },
    {
        planName: "Premium",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.premium,
        recommendationLimit: 250,
        signupLimit: 35000
    }
];
const $50757f59ceb0cbe4$export$e0b3f0eba764d747 = {
    monthly: true,
    annual: true
};

});

parcelRegister("44C4o", function(module, exports) {
$parcel$export(module.exports, "GUARD_DEFAULT_BILLING_CYCLE", function () { return $757a4e832c1a582d$export$9be98af08cc25cad; });
$parcel$export(module.exports, "GUARD_DEFAULT_UNIT_COUNT", function () { return $757a4e832c1a582d$export$d28097ea69640bd5; });
$parcel$export(module.exports, "GUARD_MIN_ENTERPRISE_USER_COUNT", function () { return $757a4e832c1a582d$export$13b500e201e8b319; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return $757a4e832c1a582d$export$91a420e9c7eb7c83; });
$parcel$export(module.exports, "guardPlanLimitConfigs", function () { return $757a4e832c1a582d$export$a2329ae21ff2ff84; });
$parcel$export(module.exports, "guardBillingCycleConfig", function () { return $757a4e832c1a582d$export$129a445945b6d9b3; });
const $757a4e832c1a582d$export$9be98af08cc25cad = "MONTHLY";
const $757a4e832c1a582d$export$d28097ea69640bd5 = 100;
const $757a4e832c1a582d$export$13b500e201e8b319 = Infinity;
const $757a4e832c1a582d$export$91a420e9c7eb7c83 = {
    standard: "atlassian-access-standard-sku",
    premium: "atlassian-guard-premium-addon-sku"
};
const $757a4e832c1a582d$export$159558c2b3d66b11 = Object.values($757a4e832c1a582d$export$91a420e9c7eb7c83);
const $757a4e832c1a582d$export$a2329ae21ff2ff84 = [
    {
        planName: "Standard",
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.standard,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Premium",
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.premium,
        recommendationLimit: 99,
        signupLimit: 50000
    }
];
const $757a4e832c1a582d$export$129a445945b6d9b3 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fEBe5", function(module, exports) {
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $6246fc483000f258$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $6246fc483000f258$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $6246fc483000f258$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $6246fc483000f258$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $6246fc483000f258$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $6246fc483000f258$export$7c96cfb0c18bfb05; });
const $6246fc483000f258$export$9423de11a8a6dfa7 = "MONTHLY";
const $6246fc483000f258$export$515fa2affea780b3 = 75;
const $6246fc483000f258$export$3df704b75c4818f2 = 201;
const $6246fc483000f258$export$84b191ede7d628ea = {
    free: "service-collection-free",
    standard: "service-collection-standard",
    premium: "service-collection-premium",
    enterprise: "service-collection-enterprise"
};
const $6246fc483000f258$export$953539e2774d6323 = Object.values($6246fc483000f258$export$84b191ede7d628ea);
const $6246fc483000f258$export$29e5f53cb4f38894 = [
    {
        planName: "Free",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000,
        minUnitCount: $6246fc483000f258$export$3df704b75c4818f2
    }
];
const $6246fc483000f258$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("9Nmuw", function(module, exports) {
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $5113a0e17f25a106$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $5113a0e17f25a106$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $5113a0e17f25a106$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $5113a0e17f25a106$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $5113a0e17f25a106$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $5113a0e17f25a106$export$120b0272a23f9b21; });
const $5113a0e17f25a106$export$f7b45b42f23a06a6 = "MONTHLY";
const $5113a0e17f25a106$export$c80f45e98f559c29 = 10;
const $5113a0e17f25a106$export$5cdb7bb84622bb8e = Infinity;
const $5113a0e17f25a106$export$6a8477cfea6a8fb8 = {
    standard: "rovodev-standard"
};
const $5113a0e17f25a106$export$69f1beff4f684452 = Object.values($5113a0e17f25a106$export$6a8477cfea6a8fb8);
const $5113a0e17f25a106$export$93aaa2531823d54e = [
    {
        planName: "Standard",
        offeringSku: $5113a0e17f25a106$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $5113a0e17f25a106$export$5cdb7bb84622bb8e
    }
];
const $5113a0e17f25a106$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});




parcelRegister("8cfMz", function(module, exports) {
$parcel$export(module.exports, "getProductCalculationInputs", function () { return $2c139569c5386442$export$915d8a609f55f86e; });

var $hrGO1 = parcelRequire("hrGO1");
const $2c139569c5386442$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});




parcelRegister("3V3tC", function(module, exports) {
$parcel$export(module.exports, "getUnitCount", function () { return $964f907284a6b353$export$f188fc3b389e4986; });
$parcel$export(module.exports, "getBillingCycle", function () { return $964f907284a6b353$export$36cee2c7009ae4b; });
$parcel$export(module.exports, "hasAnnualBilling", function () { return $964f907284a6b353$export$101e70cd0fc05902; });
$parcel$export(module.exports, "hasMonthlyBilling", function () { return $964f907284a6b353$export$9adfa96ec47fe801; });
$parcel$export(module.exports, "isUnitCountAboveMaxThreshold", function () { return $964f907284a6b353$export$bdaa994f7aee683f; });
$parcel$export(module.exports, "getUnitCountMinThreshold", function () { return $964f907284a6b353$export$80145dc7d2cff456; });
$parcel$export(module.exports, "isUnitCountBelowMinThreshold", function () { return $964f907284a6b353$export$5566acad9364293b; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $964f907284a6b353$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $964f907284a6b353$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "isOfferingRecommended", function () { return $964f907284a6b353$export$d9589e71fc109cc; });
$parcel$export(module.exports, "getUnitTierLowerBound", function () { return $964f907284a6b353$export$f88112553e09e018; });
$parcel$export(module.exports, "getUnitTierUpperBound", function () { return $964f907284a6b353$export$6f3b3ca7764acc97; });
$parcel$export(module.exports, "getUnitsAvailableInTier", function () { return $964f907284a6b353$export$daa8dd568be987ed; });
$parcel$export(module.exports, "getFormattedPlanPrice", function () { return $964f907284a6b353$export$8808c13548cf959c; });
const $964f907284a6b353$export$f188fc3b389e4986 = (ctx)=>ctx.inputValues.unitCount;
const $964f907284a6b353$export$36cee2c7009ae4b = (ctx)=>ctx.inputValues.billingCycle;
const $964f907284a6b353$export$101e70cd0fc05902 = (ctx)=>{
    return ctx.config.billingCycleConfig.annual;
};
const $964f907284a6b353$export$9adfa96ec47fe801 = (ctx)=>{
    return ctx.config.billingCycleConfig.monthly;
};
const $964f907284a6b353$export$bdaa994f7aee683f = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfig = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return unitCount > planLimitConfig.signupLimit;
};
const $964f907284a6b353$export$80145dc7d2cff456 = (ctx, offeringSku)=>{
    const { minUnitCount: minUnitCount } = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return minUnitCount !== null && minUnitCount !== void 0 ? minUnitCount : 0;
};
const $964f907284a6b353$export$5566acad9364293b = (ctx, offeringSku)=>{
    const minUnitCount = $964f907284a6b353$export$80145dc7d2cff456(ctx, offeringSku);
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    return unitCount < minUnitCount;
};
const $964f907284a6b353$export$3a3e581c62c2c0f = (ctx)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitMinEnterprise = ctx.config.unitMinEnterprise;
    return unitCount >= unitMinEnterprise;
};
const $964f907284a6b353$var$getPlanLimitConfigs = (ctx)=>{
    return ctx.config.planLimitConfigs;
};
const $964f907284a6b353$var$getPlanLimitConfig = (ctx, offeringSku)=>{
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const planLimitConfig = planLimitConfigs.find((plan)=>plan.offeringSku === offeringSku);
    if (!planLimitConfig) throw new Error("unexpected empty value");
    return planLimitConfig;
};
const $964f907284a6b353$var$getPlanPriceResult = (ctx, offeringSku)=>{
    const planPriceResult = ctx.calculationResult.find((plan)=>plan.offeringSku === offeringSku);
    if (!planPriceResult) throw new Error("unexpected empty value");
    return planPriceResult;
};
const $964f907284a6b353$export$e3c7f1437cafb58a = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    let { totalPrice: totalPrice } = price;
    const { getDiscountedPrice: getDiscountedPrice } = ctx;
    if (getDiscountedPrice) totalPrice = getDiscountedPrice({
        price: totalPrice,
        inputs: ctx.inputValues
    });
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, totalPrice);
};
const $964f907284a6b353$export$2aabcb5d2a5bee2b = (ctx, offeringSku)=>{
    const { avgPerUnitPrice: avgPerUnitPrice } = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    const { getDiscountedPrice: getDiscountedPrice } = ctx;
    if (getDiscountedPrice) return getDiscountedPrice({
        inputs: ctx.inputValues,
        price: avgPerUnitPrice
    });
    return avgPerUnitPrice;
};
const $964f907284a6b353$export$10818dfc4986524e = (price)=>{
    return Math.round(price);
};
const $964f907284a6b353$export$2dd65b072d3a3106 = (price)=>{
    return Math.ceil(price);
};
const $964f907284a6b353$export$3d36f1c8af14c3fb = (ctx)=>{
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const isJPY = currencyISOCode === "JPY";
    return isJPY ? "ja-JP" : "en-US";
};
const $964f907284a6b353$export$c86caf1be068fb8d = (ctx, price, options = {})=>{
    const numberFormatLocale = $964f907284a6b353$export$3d36f1c8af14c3fb(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    var _options_minimumFractionDigits, _options_minimumFractionDigits1;
    return new Intl.NumberFormat(numberFormatLocale, {
        style: "currency",
        currency: currencyISOCode,
        minimumFractionDigits: (_options_minimumFractionDigits = options.minimumFractionDigits) !== null && _options_minimumFractionDigits !== void 0 ? _options_minimumFractionDigits : 0,
        maximumFractionDigits: (_options_minimumFractionDigits1 = options.minimumFractionDigits) !== null && _options_minimumFractionDigits1 !== void 0 ? _options_minimumFractionDigits1 : 0
    }).format(price);
};
const $964f907284a6b353$export$b3a0d360c4444407 = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedAvgPerUnitPrice;
};
const $964f907284a6b353$export$d9589e71fc109cc = (ctx, offeringSku)=>{
    const recommendedOfferingSku = $964f907284a6b353$var$getRecommendedOfferingSku(ctx);
    return recommendedOfferingSku === offeringSku;
};
const $964f907284a6b353$var$getRecommendedOfferingSku = (ctx)=>{
    var _planLimitConfigs_recommendedPlanIdx;
    const getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
        const len = minUnitCounts.length - 1;
        return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
    };
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const recommendedPlanIdx = getRecommendedPlanIdx(unitCount, planLimitConfigs.map((productPlan)=>productPlan.recommendationLimit));
    return (_planLimitConfigs_recommendedPlanIdx = planLimitConfigs[recommendedPlanIdx]) === null || _planLimitConfigs_recommendedPlanIdx === void 0 ? void 0 : _planLimitConfigs_recommendedPlanIdx.offeringSku;
};
const $964f907284a6b353$var$getUnformattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.breakdown.at(-1);
};
const $964f907284a6b353$export$f88112553e09e018 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitLower;
};
const $964f907284a6b353$export$6f3b3ca7764acc97 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitUpper;
};
const $964f907284a6b353$export$daa8dd568be987ed = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitTierUpperBound = $964f907284a6b353$export$6f3b3ca7764acc97(ctx, offeringSku);
    return (unitTierUpperBound !== null && unitTierUpperBound !== void 0 ? unitTierUpperBound : 0) - unitCount;
};
/**
 * @deprecated
 */ const $964f907284a6b353$var$getFormattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.formattedBreakdown.at(-1);
};
const $964f907284a6b353$export$b1a3e695caa8081d = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitLower;
};
const $964f907284a6b353$export$24bf67bcc0364ee6 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitUpper;
};
const $964f907284a6b353$export$5052d5e5b6a90fdc = (ctx)=>ctx.config.currencyISOCode;
const $964f907284a6b353$export$8808c13548cf959c = (ctx, offeringSku)=>{
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    if (billingCycle === "ANNUAL") return $964f907284a6b353$export$e3c7f1437cafb58a(ctx, offeringSku);
    let price = $964f907284a6b353$export$2aabcb5d2a5bee2b(ctx, offeringSku);
    if (currencyISOCode === "JPY") {
        price = $964f907284a6b353$export$2dd65b072d3a3106(price);
        return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
            minimumFractionDigits: 0
        });
    }
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
        minimumFractionDigits: price === 0 || Number.isInteger(price) ? 0 : 2
    });
};
const $964f907284a6b353$export$235d4fbb478dfba0 = (ctx, args)=>{
    var _offering_defaultPricingPlans;
    const { offeringSku: offeringSku, edition: edition } = args;
    const offering = Object.values(ctx.config.ccpPricingData).find((offering)=>offering.sku === offeringSku);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const defaultPricingPlan = offering === null || offering === void 0 ? void 0 : (_offering_defaultPricingPlans = offering.defaultPricingPlans) === null || _offering_defaultPricingPlans === void 0 ? void 0 : _offering_defaultPricingPlans.filter((item)=>item.currency.toLowerCase() == currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() == edition.toLowerCase() && item.primaryCycle_name.toLowerCase() == billingCycle.toLowerCase() && item.status.toLowerCase() == "active");
    const lastPricingPlan = defaultPricingPlan === null || defaultPricingPlan === void 0 ? void 0 : defaultPricingPlan[defaultPricingPlan.length - 1];
    return (lastPricingPlan === null || lastPricingPlan === void 0 ? void 0 : lastPricingPlan.id) || "";
};

});


parcelRegister("hEIeM", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return (parcelRequire("MgH7i")).PricingCalculatorInputs; });
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return (parcelRequire("kBDDI")).RovoDevStandardPriceCard; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionEnterprisePriceCard; });
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionFreePriceCard; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionPremiumPriceCard; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionStandardPriceCard; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return (parcelRequire("v7O5E")).LoomBusinessPlusAiPriceCard; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return (parcelRequire("v7O5E")).LoomBusinessPriceCard; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return (parcelRequire("v7O5E")).LoomEnterprisePriceCard; });
$parcel$export(module.exports, "LoomFreePriceCard", function () { return (parcelRequire("v7O5E")).LoomFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryPremiumPriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryStandardPriceCard; });
$parcel$export(module.exports, "LoadingSpinner", function () { return (parcelRequire("5TIjy")).LoadingSpinner; });
$parcel$export(module.exports, "PriceAltContainer", function () { return (parcelRequire("iXfHC")).PriceAltContainer; });
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return (parcelRequire("9Osbp")).MonthlyEnterpriseMessage; });
$parcel$export(module.exports, "getFeaturesList", function () { return (parcelRequire("44bDI")).getFeaturesList; });
$parcel$export(module.exports, "UserTier", function () { return (parcelRequire("lbUj4")).UserTier; });
$parcel$export(module.exports, "UserTierExpanded", function () { return (parcelRequire("lbUj4")).UserTierExpanded; });
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return (parcelRequire("7khdS")).useLocalizedCtaUrl; });
parcelRequire("MgH7i");

var $5TIjy = parcelRequire("5TIjy");

var $iXfHC = parcelRequire("iXfHC");

var $9Osbp = parcelRequire("9Osbp");

var $44bDI = parcelRequire("44bDI");

var $lbUj4 = parcelRequire("lbUj4");

var $7khdS = parcelRequire("7khdS");
parcelRequire("kBDDI");
parcelRequire("9hJtd");
parcelRequire("v7O5E");
parcelRequire("1NsjC");

});
parcelRegister("MgH7i", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return $884c8db4d1ecaa10$export$8c44531ca473ca22; });
/* pricing-calculator-inputs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $hrGO1 = parcelRequire("hrGO1");

var $4pGAV = parcelRequire("4pGAV");

var $kbpa7 = parcelRequire("kbpa7");

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
const $884c8db4d1ecaa10$export$8c44531ca473ca22 = (props)=>{
    const { unitCountLabel: unitCountLabel, unitsLabel: unitsLabel, dataProductKey: dataProductKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [billingCycle, setBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount, setUnitCount] = (0, $1CtPM.useUnitCount)();
    const hasMonthlyBilling = (0, $1CtPM.useSelector)($3V3tC.hasMonthlyBilling);
    const hasAnnualBilling = (0, $1CtPM.useSelector)($3V3tC.hasAnnualBilling);
    const [visualUnitCount, setVisualUnitCount] = (0, $1oC0p.useState)(// @ts-ignore
    unitCount);
    (0, $1oC0p.useEffect)(()=>{
        if (visualUnitCount !== "" && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) // @ts-ignore
        setUnitCount(visualUnitCount);
    }, [
        visualUnitCount
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === "") return setVisualUnitCount("");
        // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        // @ts-ignore
        if (visualUnitCount === "") setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: `${(0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: "input",
            event: "blurred",
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox,
            action: "blurred",
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (billingCycle)=>{
        const data = {
            billingCycle: billingCycle,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: "radioButton",
            event: "clicked",
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: "clicked",
            attributes: data
        }).fire();
        setBillingCycle(billingCycle);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1hlo"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                },
                                children: unitCountLabel
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $2jatx.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $2jatx.default)([
                                    "_syaz1mpp _ect4bzd7 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: unitsLabel
                            })
                        ]
                    }),
                    hasMonthlyBilling && hasAnnualBilling && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4pGAV.RadioButtons), {
                            wrap: false,
                            dataProductKey: dataProductKey,
                            selectedButtonId: billingCycle,
                            onChange: handleRadioChange,
                            groupLabel: /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_1aax1e5h"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "Pricing.priceFinderInputs.billMeText",
                                    defaultMessage: "Bill me:"
                                })
                            }),
                            buttons: [
                                {
                                    id: "MONTHLY",
                                    label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.priceFinderInputs.monthly",
                                        defaultMessage: "Monthly"
                                    })
                                },
                                {
                                    id: "ANNUAL",
                                    label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.pricingCalculatorInputs.anually",
                                        defaultMessage: "Annually"
                                    }),
                                    lozenge: {
                                        appearance: "blue",
                                        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "Pricing.pricingCalculatorInputs.saveUpTo",
                                            defaultMessage: "SAVE UP TO 17%"
                                        })
                                    }
                                }
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $884c8db4d1ecaa10$var$labelStyles = null;
const $884c8db4d1ecaa10$var$legendStyles = null;
const $884c8db4d1ecaa10$var$inputTermStyle = null;
const $884c8db4d1ecaa10$var$inputCss = null;

});

parcelRegister("5TIjy", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $5e560a7364105b43$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $7qFQI = parcelRequire("7qFQI");
const $5e560a7364105b43$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "global-nav-user-profile-container-spinner",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {})
        })
    });

});

parcelRegister("iXfHC", function(module, exports) {
$parcel$export(module.exports, "PriceAltContainer", function () { return $886eaf760740e014$export$4e62248194b0727b; });
/* price-alt-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");
const $886eaf760740e014$export$4e62248194b0727b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _y3gn1h6o"
        ]),
        children: props.children
    }));
};
const $886eaf760740e014$var$priceAltTextCss = null;

});

parcelRegister("9Osbp", function(module, exports) {
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return $2abbf2119b6f777e$export$16f86c6a635bb9af; });
/* monthly-enterprise-message.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");
const $2abbf2119b6f777e$export$16f86c6a635bb9af = (props)=>{
    const { switchToAnnual: switchToAnnual } = props;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iXfHC.PriceAltContainer), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: switchToAnnual,
                tabIndex: 0,
                "data-event-component": "linkButton",
                "data-event": "clicked",
                className: (0, $2jatx.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _syaz17la _ect41kw7 _1wyb1kw7 _vwz4idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                },
                children: intl.formatMessage($9evy5.billedAnnually)
            }),
            "\xa0",
            intl.formatMessage($9evy5.switchToAnnualToViewEnterprise)
        ]
    });
};
const $2abbf2119b6f777e$var$buttonCss = null;

});
parcelRegister("9evy5", function(module, exports) {
$parcel$export(module.exports, "recommended", function () { return $b8ce4f4c86785928$export$bc5b8d0824876806; });
$parcel$export(module.exports, "units", function () { return $b8ce4f4c86785928$export$fe0319385f0cf5a7; });
$parcel$export(module.exports, "perUserPerMonth", function () { return $b8ce4f4c86785928$export$d8b49137e99effc2; });
$parcel$export(module.exports, "perYear", function () { return $b8ce4f4c86785928$export$5eae4ab34e5b16ae; });
$parcel$export(module.exports, "aboveUnitMaxThreshold", function () { return $b8ce4f4c86785928$export$bf2ba8467ff15aa5; });
$parcel$export(module.exports, "belowUnitMinThreshold", function () { return $b8ce4f4c86785928$export$2e64ce41e89d1e18; });
$parcel$export(module.exports, "billedAnnually", function () { return $b8ce4f4c86785928$export$9e1a6bb525180618; });
$parcel$export(module.exports, "switchToAnnualToViewEnterprise", function () { return $b8ce4f4c86785928$export$3277af2b318f7bfa; });
$parcel$export(module.exports, "enterpriseJpyMessage", function () { return $b8ce4f4c86785928$export$68a1387c7d0a683f; });

var $fnHPc = parcelRequire("fnHPc");
const $b8ce4f4c86785928$export$bc5b8d0824876806 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.recommended",
    defaultMessage: "Recommended"
});
const $b8ce4f4c86785928$export$fe0319385f0cf5a7 = (0, $fnHPc.defineMessages)({
    teamSizePrompt: {
        id: "priceFinder.teamSizePrompt",
        defaultMessage: "Team Size:"
    },
    usersUnitsLabel: {
        id: "priceFinder.usersUnitsLabel",
        defaultMessage: "users"
    },
    agentsUnitsLabel: {
        id: "priceFinder.agentsUnitsLabel",
        defaultMessage: "agents"
    }
});
const $b8ce4f4c86785928$export$d8b49137e99effc2 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.perUnitPerMonth",
    defaultMessage: "per user / month"
});
const $b8ce4f4c86785928$export$5eae4ab34e5b16ae = (0, $fnHPc.defineMessage)({
    id: "priceFinder.perYear",
    defaultMessage: "per year"
});
const $b8ce4f4c86785928$export$bf2ba8467ff15aa5 = (0, $fnHPc.defineMessages)({
    default: {
        id: "priceFinder.aboveUserMaxThreshold.default",
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: "priceFinder.aboveUserMaxThreshold.cloudEnterprise",
        defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
    },
    agents: {
        id: "priceFinder.aboveUserMaxThreshold.agents",
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: "priceFinder.aboveUserMaxThreshold.specificCount",
        defaultMessage: "For teams of more than {lowerLimit}, contact our sales team."
    },
    creators: {
        id: "priceFinder.aboveUserMaxThreshold.creators",
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});
const $b8ce4f4c86785928$export$2e64ce41e89d1e18 = (0, $fnHPc.defineMessages)({
    cloudEnterprise: {
        id: "priceFinder.belowUnitMinThreshold.cloudEnterprise",
        defaultMessage: "Enterprise plan pricing is available when you enter {minUnitCount} or more users above"
    }
});
const $b8ce4f4c86785928$export$9e1a6bb525180618 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.billedAnnually",
    defaultMessage: "Billed annually."
});
const $b8ce4f4c86785928$export$3277af2b318f7bfa = (0, $fnHPc.defineMessage)({
    id: "priceFinder.switchToAnnualToViewEnterprise",
    defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
});
const $b8ce4f4c86785928$export$68a1387c7d0a683f = (0, $fnHPc.defineMessage)({
    id: "priceFinder.enterpriseJpyMessage",
    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
});

});


parcelRegister("44bDI", function(module, exports) {
$parcel$export(module.exports, "getFeaturesList", function () { return $b83af44fbf5738a9$export$501f60b80ced167; });
/* features-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cXZQx = parcelRequire("cXZQx");

var $gVC4y = parcelRequire("gVC4y");
const $b83af44fbf5738a9$export$501f60b80ced167 = (highlightedFeaturesContainer)=>{
    return highlightedFeaturesContainer === null || highlightedFeaturesContainer === void 0 ? void 0 : highlightedFeaturesContainer.map((feature)=>({
            label: feature.fields.highlightedFeatureTitleExternal,
            details: feature.fields.highlightedFeatureDetails && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_q7gqdlk8"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cXZQx.RichTextComponent), {
                    text: (0, $gVC4y.richTextToHTML)(// @ts-ignore
                    feature.fields.highlightedFeatureDetails)
                })
            }),
            lozengeText: feature.fields.highlightedLabel
        }));
};
const $b83af44fbf5738a9$var$featureDetailsCss = null;

});

parcelRegister("lbUj4", function(module, exports) {
$parcel$export(module.exports, "UserTier", function () { return $b9de452da2cf6ac9$export$cd4f9ca719669f8d; });
$parcel$export(module.exports, "UserTierExpanded", function () { return $b9de452da2cf6ac9$export$a4c8408bf932bb2; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");
const $b9de452da2cf6ac9$export$cd4f9ca719669f8d = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, numberFormatLocale: numberFormatLocale = "en-US", unitType: unitType } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    if (unitType === "agent") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PricingCalculator.agentTier.range",
        defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}",
        values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PriceFunder.userTier.range",
        defaultMessage: "User tier: {lowerLimit} - {upperLimit}",
        values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
};
const $b9de452da2cf6ac9$export$a4c8408bf932bb2 = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsInTier: unitsInTier, unitsAvailableInTier: unitsAvailableInTier, numberFormatLocale: numberFormatLocale = "en-US" } = props;
    const intl = (0, $8e22h.default)();
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.tier),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitLimitLower),
                    " - ",
                    formatNumber(unitLimitUpper)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.filledSeats),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitsInTier)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.availableSeats),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitsAvailableInTier)
                ]
            })
        ]
    });
};
const $b9de452da2cf6ac9$var$messages = (0, $fnHPc.defineMessages)({
    tier: {
        id: "PriceFinder.userTier.tier",
        defaultMessage: "Tier:"
    },
    filledSeats: {
        id: "PriceFinder.userTier.filledSeats",
        defaultMessage: "Filled seats:"
    },
    availableSeats: {
        id: "PriceFinder.userTier.availableSeats",
        defaultMessage: "Available seats:"
    }
});

});

parcelRegister("7khdS", function(module, exports) {
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33; });

var $kooLp = parcelRequire("kooLp");
function $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33(ctaFields) {
    var _ctaFields_ctaUrl;
    return (0, $kooLp.useLocalizedHref)((0, $kooLp.absoluteToRelativeHref)((_ctaFields_ctaUrl = ctaFields === null || ctaFields === void 0 ? void 0 : ctaFields.ctaUrl) !== null && _ctaFields_ctaUrl !== void 0 ? _ctaFields_ctaUrl : ""));
}

});

parcelRegister("kBDDI", function(module, exports) {
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return $429cde05ec573ae0$export$f0e8bcb2fb60056a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $429cde05ec573ae0$export$f0e8bcb2fb60056a = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        isSingleCard: true,
        monthlyPerUserLabel: intl.formatMessage({
            id: "RovoDevStandardPriceCard.monthlyPerUserLabel",
            defaultMessage: "per developer / month"
        })
    }));
};

});
parcelRegister("2Wido", function(module, exports) {
$parcel$export(module.exports, "FreePriceCard", function () { return $fd07704e9f8e1231$export$75a717cafbbb6b29; });
$parcel$export(module.exports, "StandardPriceCard", function () { return $fd07704e9f8e1231$export$b2f3ad255eaef337; });
$parcel$export(module.exports, "PremiumPriceCard", function () { return $fd07704e9f8e1231$export$51a8509266751bd0; });
$parcel$export(module.exports, "EnterprisePriceCard", function () { return $fd07704e9f8e1231$export$ba2214b2dcd26743; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $BSG7c = parcelRequire("BSG7c");

var $2wDsW = parcelRequire("2wDsW");

var $lOlsU = parcelRequire("lOlsU");

var $8HBY7 = parcelRequire("8HBY7");

var $gJe05 = parcelRequire("gJe05");
parcelRequire("hEIeM");
var $44bDI = parcelRequire("44bDI");
var $9Osbp = parcelRequire("9Osbp");
var $iXfHC = parcelRequire("iXfHC");
var $7khdS = parcelRequire("7khdS");
var $lbUj4 = parcelRequire("lbUj4");

var $1CtPM = parcelRequire("1CtPM");

var $9evy5 = parcelRequire("9evy5");

var $3V3tC = parcelRequire("3V3tC");
function $fd07704e9f8e1231$var$usePriceCardEvents(props) {
    const { productKey: productKey, edition: edition } = props;
    const tryIntent = (0, $2wDsW.useTryIntent)({
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER),
        intentType: "button",
        productKey: productKey,
        edition: edition
    });
    const handleClickCta = (0, $lOlsU.useFirePricingPlanCtaEvent)({
        edition: edition,
        productKey: productKey,
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER)
    });
    return {
        onClick: ()=>{
            tryIntent.onClick();
            handleClickCta();
        },
        onKeyDown: tryIntent.onKeyDown
    };
}
const $fd07704e9f8e1231$var$FREE_EDITION = "free";
const $fd07704e9f8e1231$export$75a717cafbbb6b29 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: $fd07704e9f8e1231$var$FREE_EDITION
    });
    const dataEventPropsLabel = `${$fd07704e9f8e1231$var$FREE_EDITION}-get-it-now`;
    const urlWithSignupSource = new URL(ctaUrl, window.location.origin);
    urlWithSignupSource.searchParams.set("signupSource", "pricing");
    const buttonHref = urlWithSignupSource.toString();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: state.price,
        hasUnitSlot: true,
        hasRangeSlot: props.hasRangeSlot !== undefined ? props.hasRangeSlot : state.billingCycle === "ANNUAL",
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonVariant: state.recommended ? "primary" : "secondary",
        buttonHref: buttonHref,
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$var$STANDARD_EDITION = "standard";
const $fd07704e9f8e1231$var$PREMIUM_EDITION = "premium";
const $fd07704e9f8e1231$export$b2f3ad255eaef337 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fd07704e9f8e1231$var$CommonPriceCard, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        edition: $fd07704e9f8e1231$var$STANDARD_EDITION
    }));
const $fd07704e9f8e1231$export$51a8509266751bd0 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fd07704e9f8e1231$var$CommonPriceCard, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        edition: $fd07704e9f8e1231$var$PREMIUM_EDITION
    }));
// eslint-disable-next-line complexity
const $fd07704e9f8e1231$var$CommonPriceCard = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, tierLabelType: tierLabelType, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const dataEventPropsLabel = `${props.edition}-start-trial`;
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: props.edition
    });
    const priceAltElement = (()=>{
        if (state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined) return props.priceAltElementForAboveMaxThreshold;
        return null;
    })();
    const urlWithSignupSource = new URL(ctaUrl, window.location.origin);
    urlWithSignupSource.searchParams.set("signupSource", "pricing");
    const buttonHref = urlWithSignupSource.toString();
    var _props_monthlyPerUserLabel;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === "ANNUAL" ? "annual-price" : "monthly-price",
        hasRangeSlot: state.isUnitCountAboveMaxThreshold && currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: !state.isUnitCountAboveMaxThreshold && state.price,
        priceAltElement: state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined ? priceAltElement : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.default)
        }),
        unit: state.isUnitCountAboveMaxThreshold ? undefined : state.billingCycle === "MONTHLY" ? (_props_monthlyPerUserLabel = props.monthlyPerUserLabel) !== null && _props_monthlyPerUserLabel !== void 0 ? _props_monthlyPerUserLabel : intl.formatMessage($9evy5.perUserPerMonth) : intl.formatMessage($9evy5.perYear),
        hasUnitSlot: true,
        range: state.billingCycle === "ANNUAL" && !props.omitRange && !state.isUnitCountAboveMaxThreshold && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        }),
        tooltipContent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        }),
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: buttonHref,
        buttonDisabled: state.isUnitCountAboveMaxThreshold,
        buttonVariant: state.recommended || props.isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$export$ba2214b2dcd26743 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, showBannerText: showBannerText = true, isSingleCard: isSingleCard, tierLabelType: tierLabelType, customBannerText: customBannerText, isJpyPriceEnabled: isJpyPriceEnabled } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const [_, changeBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const priceAltElement = (()=>{
        if (props.priceAltElement !== undefined) return props.priceAltElement;
        if (currencyIsoCode === "JPY" && !isJpyPriceEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.enterpriseJpyMessage)
        });
        if (state.billingCycle === "MONTHLY") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "24px"
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Osbp.MonthlyEnterpriseMessage), {
                switchToAnnual: ()=>changeBillingCycle("ANNUAL")
            })
        });
        if (state.isUnitCountAboveMaxThreshold) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.cloudEnterprise)
        });
        if (state.isUnitCountBelowMinThreshold) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($9evy5.belowUnitMinThreshold.cloudEnterprise, {
                minUnitCount: state.unitCountMin
            })
        });
        return null;
    })();
    const isPriceShown = !state.isUnitCountAboveMaxThreshold && !priceAltElement;
    let price = undefined;
    let range = undefined;
    let tooltipContent = undefined;
    if (isPriceShown) {
        price = state.price;
        range = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        });
        tooltipContent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        });
    }
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const edition = "enterprise";
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: edition
    });
    const dataEventPropsLabel = `${edition}-contact-sales`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === "ANNUAL" ? "annual-price" : "monthly-price",
        hasBannerSlot: true,
        hasRangeSlot: currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : showBannerText && state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: price,
        priceAltElement: priceAltElement,
        unit: // if a price alt element exists, there should be no unit
        priceAltElement ? undefined : !state.isUnitCountAboveMaxThreshold && !state.isUnitCountBelowMinThreshold ? intl.formatMessage($9evy5.perYear) : undefined,
        range: range,
        hasUnitSlot: // the unbounded text for the price alt element makes the unbounded
        currencyIsoCode === "JPY",
        tooltipContent: tooltipContent,
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: ctaUrl,
        buttonVariant: state.recommended || isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        // in order for us to render just the top section fo a pricing card, the contentful data must be empty/undefined
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};

});
parcelRegister("BSG7c", function(module, exports) {
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $d0bc5feae5415d38$export$c5526af38120e3f; });
const $d0bc5feae5415d38$export$c5526af38120e3f = "priceBlock";

});



parcelRegister("9hJtd", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return $e9537e62b8dac42c$export$ce09fc7b6ac40092; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return $e9537e62b8dac42c$export$84affe19123eb209; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return $e9537e62b8dac42c$export$1383d1ba03ed3746; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return $e9537e62b8dac42c$export$c277b80f2da61f89; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $e9537e62b8dac42c$export$ce09fc7b6ac40092 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$84affe19123eb209 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$1383d1ba03ed3746 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$c277b80f2da61f89 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};

});

parcelRegister("v7O5E", function(module, exports) {
$parcel$export(module.exports, "LoomFreePriceCard", function () { return $c7b8be01488760da$export$947796c8957ff6ff; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return $c7b8be01488760da$export$2a7af2744a13b8c2; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return $c7b8be01488760da$export$efaf4c20492b36b7; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return $c7b8be01488760da$export$d88b84b01ca5e441; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $1CtPM = parcelRequire("1CtPM");

var $2Wido = parcelRequire("2Wido");
const $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD = 26;
const $c7b8be01488760da$export$947796c8957ff6ff = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        hasRangeSlot: omitRange ? false : undefined
    }));
};
const $c7b8be01488760da$export$2a7af2744a13b8c2 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange
    }));
};
const $c7b8be01488760da$export$efaf4c20492b36b7 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    const intl = (0, $8e22h.default)();
    const customBannerText = intl.formatMessage({
        id: "LoomBusinessPlusAiPriceCard.mostPopular",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        customBannerText: customBannerText
    }));
};
const $c7b8be01488760da$export$d88b84b01ca5e441 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        priceAltElement: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
    }));
};
const $c7b8be01488760da$var$useOmitRange = ()=>{
    const [billingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount] = (0, $1CtPM.useUnitCount)();
    return billingCycle === "ANNUAL" && unitCount < $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD;
};

});

parcelRegister("1NsjC", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return $bb1064deffe4f718$export$9301352401a96395; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return $bb1064deffe4f718$export$f632b4bee5bd80fe; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return $bb1064deffe4f718$export$1fb355a43910f211; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $bb1064deffe4f718$export$9301352401a96395 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), (0, $6ogO3._)({}, props));
};
const $bb1064deffe4f718$export$f632b4bee5bd80fe = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    }));
};
const $bb1064deffe4f718$export$1fb355a43910f211 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    }));
};

});


parcelRegister("fhn1A", function(module, exports) {
$parcel$export(module.exports, "useProviderProps", function () { return $00fd412ee2189aba$export$521c373ccc32c300; });
// @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1XfW0 = parcelRequire("1XfW0");

var $hu3Tl = parcelRequire("hu3Tl");

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");

var $1CtPM = parcelRequire("1CtPM");
function $00fd412ee2189aba$export$521c373ccc32c300(props) {
    const { plans: plans, product: product, inputValues: inputValues } = props;
    const billingCycle = inputValues === null || inputValues === void 0 ? void 0 : inputValues.billingCycle;
    const unitCount = inputValues === null || inputValues === void 0 ? void 0 : inputValues.unitCount;
    const locale = (0, $1XfW0.useLocale)();
    const currencyISOCode = (0, $hu3Tl.getCurrencyFromUserLocale)(locale);
    const ssrData = plans.reduce((acc, plan)=>{
        return (0, $dPABA._)((0, $6ogO3._)({}, acc), {
            [plan.fields.sku]: plan.pricingPlan
        });
    }, {});
    const { data: ccpPricingData, status: status } = (0, $1CtPM.useCcpPricingData)({
        offeringSkus: plans.map((plan)=>plan.fields.sku),
        ssrData: ssrData
    });
    if (status === "error") return {
        status: "error"
    };
    if (status === "pending") return {
        status: "pending"
    };
    if (product === "jira") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $j1ORI.JIRA_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $j1ORI.JIRA_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $j1ORI.jiraPlanLimitConfigs,
                unitMinEnterprise: $j1ORI.JIRA_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "confluence") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $29JVp.CONFLUENCE_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $29JVp.CONFLUENCE_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $29JVp.confluencePlanLimitConfigs,
                unitMinEnterprise: $29JVp.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "teamwork") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $YmHME.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $YmHME.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $YmHME.teamworkCollectionPlanLimitConfigs,
                unitMinEnterprise: $YmHME.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $YmHME.teamworkCollectionBillingCycleConfig
            }
        }
    };
    if (product === "guard") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $44C4o.GUARD_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $44C4o.GUARD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $44C4o.guardPlanLimitConfigs,
                unitMinEnterprise: $44C4o.GUARD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $44C4o.guardBillingCycleConfig
            }
        }
    };
    if (product === "bitbucket") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $aTHox.BITBUCKET_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $aTHox.BITBUCKET_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $aTHox.bitbucketPlanLimitConfigs,
                unitMinEnterprise: $aTHox.BITBUCKET_MIN_ENTERPRISE_USER_COUNT,
                // bitbucket only supports USD
                currencyISOCode: "USD",
                localeISOCode: locale,
                billingCycleConfig: $aTHox.bitbucketBillingCycleConfig
            }
        }
    };
    if (product === "strategy") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $hGYMM.STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $hGYMM.STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $hGYMM.strategyCollectionPlanLimitConfigs,
                unitMinEnterprise: $hGYMM.STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $hGYMM.strategyCollectionBillingCycleConfig
            }
        }
    };
    if (product === "compass") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $7dhmX.COMPASS_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $7dhmX.COMPASS_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $7dhmX.compassPlanLimitConfigs,
                // not sure why this field is necessary
                unitMinEnterprise: $7dhmX.COMPASS_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $7dhmX.compassBillingCycleConfig
            }
        }
    };
    if (product === "service") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $fEBe5.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $fEBe5.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fEBe5.serviceCollectionPlanLimitConfigs,
                unitMinEnterprise: $fEBe5.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fEBe5.serviceCollectionBillingCycleConfig
            }
        }
    };
    if (product === "rovo-dev") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $9Nmuw.ROVO_DEV_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $9Nmuw.ROVO_DEV_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $9Nmuw.rovoDevPlanLimitConfigs,
                unitMinEnterprise: $9Nmuw.ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $9Nmuw.rovoDevBillingCycleConfig
            }
        }
    };
    if (product === "loom") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $4utnL.LOOM_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $4utnL.LOOM_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $4utnL.loomPlanLimitConfigs,
                unitMinEnterprise: $4utnL.LOOM_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $4utnL.loomBillingCycleConfig
            }
        }
    };
    if (product === "product-discovery") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $lc7EO.JPD_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $lc7EO.JPD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $lc7EO.jpdPlanLimitConfigs,
                unitMinEnterprise: $lc7EO.JPD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $lc7EO.jpdBillingCycleConfig
            }
        }
    };
    throw new Error("unknown product");
}

});
parcelRegister("1XfW0", function(module, exports) {
"use strict";
var $16c7a96eeffbdd9b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $16c7a96eeffbdd9b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $16c7a96eeffbdd9b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$16c7a96eeffbdd9b$var$__exportStar((parcelRequire("dbu8X")), module.exports);

});
parcelRegister("dbu8X", function(module, exports) {
"use strict";
var $9993af4ecc11ada2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9993af4ecc11ada2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9993af4ecc11ada2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9993af4ecc11ada2$var$__exportStar((parcelRequire("d7zsU")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("c09cG")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("9sIvp")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("4Hi5f")), module.exports);

});
parcelRegister("d7zsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCALES = module.exports.LOCALE_REGISTRY = module.exports.DEFAULT_LOCALE = void 0;
module.exports.DEFAULT_LOCALE = "en";
module.exports.LOCALE_REGISTRY = Object.freeze({
    [module.exports.DEFAULT_LOCALE]: {
        label: "English"
    },
    de: {
        label: "Deutsch"
    },
    es: {
        label: "Espa\xf1ol"
    },
    fr: {
        label: "Fran\xe7ais"
    },
    it: {
        label: "Italiano"
    },
    ko: {
        label: "\uD55C\uAD6D\uC5B4"
    },
    nl: {
        label: "Nederlands"
    },
    ja: {
        label: "\u65E5\u672C\u8A9E"
    },
    pl: {
        label: "Polski"
    },
    br: {
        label: "Portugu\xeas"
    },
    ru: {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    zh: {
        label: "\u4E2D\u6587"
    }
});
module.exports.LOCALES = Object.keys(module.exports.LOCALE_REGISTRY);

});

parcelRegister("c09cG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocale = $8bcc9fc4fdd32787$var$useLocale;

var $8e22h = parcelRequire("8e22h");
function $8bcc9fc4fdd32787$var$useLocale() {
    const intl = (0, $8e22h.default)();
    return intl.locale;
}

});

parcelRegister("9sIvp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocalizedHref = $6e394074629606a1$var$useLocalizedHref;

var $d7zsU = parcelRequire("d7zsU");

var $c09cG = parcelRequire("c09cG");
function $6e394074629606a1$var$useLocalizedHref(href) {
    const locale = (0, $c09cG.useLocale)();
    if (locale === $d7zsU.DEFAULT_LOCALE) return href;
    else return `/${locale}${href}`;
}

});

parcelRegister("4Hi5f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_VALUES = void 0;

var $7VQPk = parcelRequire("7VQPk");
module.exports.DEFAULT_VALUES = Object.freeze({
    br: (0, $7VQPk.jsx)("br", {}),
    p: (chunks)=>(0, $7VQPk.jsx)("p", {
            children: chunks
        }),
    strong: (chunks)=>(0, $7VQPk.jsx)("strong", {
            children: chunks
        }),
    span: (chunks)=>(0, $7VQPk.jsx)("span", {
            children: chunks
        })
});

});




parcelRegister("juRep", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorCard", function () { return $1b9806dc7038eb23$export$14072311c149f96f; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $4G0xh = parcelRequire("4G0xh");
parcelRequire("hEIeM");
var $1NsjC = parcelRequire("1NsjC");
var $v7O5E = parcelRequire("v7O5E");
var $kBDDI = parcelRequire("kBDDI");
var $9hJtd = parcelRequire("9hJtd");

var $eCYOL = parcelRequire("eCYOL");

var $2Wido = parcelRequire("2Wido");

var $aTHox = parcelRequire("aTHox");
parcelRequire("b9I0b");
var $7dhmX = parcelRequire("7dhmX");
var $29JVp = parcelRequire("29JVp");
var $44C4o = parcelRequire("44C4o");
var $j1ORI = parcelRequire("j1ORI");
var $lc7EO = parcelRequire("lc7EO");
var $4utnL = parcelRequire("4utnL");
var $9Nmuw = parcelRequire("9Nmuw");
var $fEBe5 = parcelRequire("fEBe5");
var $hGYMM = parcelRequire("hGYMM");
var $YmHME = parcelRequire("YmHME");
const $1b9806dc7038eb23$export$14072311c149f96f = (props)=>{
    const sku = props.planData.fields.sku;
    const trackingProductKey = (0, $4G0xh.urlSlugToDataProductKey)[props.urlSlug];
    switch(sku){
        // Free
        case (0, $j1ORI.jiraOfferingSkus).free:
        case (0, $29JVp.confluenceOfferingSkus).free:
        case (0, $YmHME.teamworkCollectionOfferingSkus).free:
        case (0, $7dhmX.compassOfferingSkus).free:
        case (0, $aTHox.bitbucketOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Standard
        case (0, $j1ORI.jiraOfferingSkus).standard:
        case (0, $29JVp.confluenceOfferingSkus).standard:
        case (0, $YmHME.teamworkCollectionOfferingSkus).standard:
        case (0, $44C4o.guardOfferingSkus).standard:
        case (0, $7dhmX.compassOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $aTHox.bitbucketOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCYOL.BitbucketStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Premium
        case (0, $j1ORI.jiraOfferingSkus).premium:
        case (0, $29JVp.confluenceOfferingSkus).premium:
        case (0, $YmHME.teamworkCollectionOfferingSkus).premium:
        case (0, $44C4o.guardOfferingSkus).premium:
        case (0, $7dhmX.compassOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $aTHox.bitbucketOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCYOL.BitbucketPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Enterprise
        case (0, $j1ORI.jiraOfferingSkus).enterprise:
        case (0, $29JVp.confluenceOfferingSkus).enterprise:
        case (0, $YmHME.teamworkCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), (0, $6ogO3._)({}, props));
        case (0, $hGYMM.strategyCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                isJpyPriceEnabled: true
            }));
        // Custom, for any tier
        case (0, $9Nmuw.rovoDevOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kBDDI.RovoDevStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionEnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).business:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomBusinessPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).businessPlusAi:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomBusinessPlusAiPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomEnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        default:
            // todo: @bsparks GWP-6943 fire an event for unexpected sku
            return null;
    }
};

});
parcelRegister("eCYOL", function(module, exports) {
$parcel$export(module.exports, "BitbucketStandardPriceCard", function () { return $cb5a2cb54b1cfed2$export$3f65201715c64fe0; });
$parcel$export(module.exports, "BitbucketPremiumPriceCard", function () { return $cb5a2cb54b1cfed2$export$3845e26e0454185b; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $aTHox = parcelRequire("aTHox");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $cb5a2cb54b1cfed2$export$3f65201715c64fe0 = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};
const $cb5a2cb54b1cfed2$export$3845e26e0454185b = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};

});





//# sourceMappingURL=jira-software-page.600d9606.js.map
